// extracted by mini-css-extract-plugin
module.exports = {"b1hnyx5d":"b1hnyx5d","c11zq5gm":"c11zq5gm"};